'use strict';

module.exports = function () {
    // Allowing tooltip buttons to remain focusable so they are accessible to screen readers
    $('.tooltip-icon').attr('tabindex', '0');


    $('.info-icon').on('mouseenter focusin', function () {
        $(this).find('.tooltip').removeClass('d-none');
    });

    $('.info-icon').on('mouseleave focusout', function () {
        $(this).find('.tooltip').addClass('d-none');
    });
};
